import type { SxProps, Theme } from "@mui/material";
import { Box, useTheme } from "@mui/material";

interface NewDotProps {
  sx?: SxProps<Theme>;
}

/** 6px "new" dot — compact stand-in for NewTag where there's no room for text
 *  (e.g. collapsed sidebar icons). Position it via `sx`. */
export const NewDot = ({ sx }: NewDotProps) => {
  const theme = useTheme();
  return (
    <Box
      aria-hidden
      sx={[
        {
          width: "6px",
          height: "6px",
          borderRadius: "50%",
          flexShrink: 0,
          backgroundColor: theme.palette.purple.main,
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    />
  );
};
